const DOG_ADVENT_CALENDAR_PRODUCT_ID = '14779418181358592';
const CAT_ADVENT_CALENDAR_PRODUCT_ID = '14779513693268992';

const PINNED_UPSELL_PRODUCT_IDS: ReadonlySet<string> = new Set([
  DOG_ADVENT_CALENDAR_PRODUCT_ID,
  CAT_ADVENT_CALENDAR_PRODUCT_ID,
]);

export const isPinnedUpsellProduct = (productId: string): boolean =>
  PINNED_UPSELL_PRODUCT_IDS.has(productId);
